import { setupToc } from './table-of-contents';

jQuery(($) => {
    function copyLink () {
        $('.copy-link').each(function () {
            $(this).on('click', () => {
                var $url = $(this).attr('data-clipboard-text');
                navigator.clipboard.writeText($url);
            });
        });
    }

    function keyDatesCarousel () {
        $('.owl-carousel').owlCarousel({
            margin: 10,
            responsiveClass: true,
            navText: false,
            navElement: 'button',
            responsive: {
                0: {
                    items: 1,
                    nav: true,
                    dots: false
                },
                768: {
                    items: 3,
                    nav: true,
                    dots: false
                },
                1000: {
                    items: 4,
                    nav: true,
                    dots: false
                }
            }
        });

        if ($('.owl-item').length > 4) {
            $('.date-link:gt(3)').attr('tabindex', '-1');
            $('.owl-next').on('click', (e) => {
                $('.date-link:gt(3)').attr('tabindex', '0');
            });
        };

        $('.owl-carousel .owl-next').attr('aria-label', 'View next key dates');
        $('.owl-carousel .owl-prev').attr('aria-label', 'View previous key dates');
    }

    function activeCarouselItem () {
        $('.menu-item').each(function () {
            const $this = $(this);
            $this.on('click', function () {
                const clickedCarouselItem = $(this).attr('data-hash');
                $('.menu-item').siblings().removeClass('active');
                $(`.menu-item[data-hash=${clickedCarouselItem}]`).addClass('active').addClass('clicked');
            });
        });
    }

    function megamenu () {
        $('.mega-menu').on('click', (e) => {
            $('.menu-wrapper').toggleClass('is-hidden');
            if ($('.menu-wrapper').hasClass('is-hidden')) {
                $('.menu-wrapper').attr('aria-expanded', 'false');
                $('.mega-menu').removeClass('active');
                $('.menu-label').removeClass('active');
            } else {
                $('.menu-wrapper').attr('aria-expanded', 'true');
            }
        });

        $('.mega-menu a').click(function (e) {
            e.stopPropagation();
        });

        $('.menu-label').each(function () {
            const $this = $(this);

            $this.on('click', function (e) {
                $this.toggleClass('active')
                    .siblings()
                    .removeClass('active')
                    .children('.mega-menu')
                    .removeClass('active');

                $(`.mega-menu[data-id='${$(this).data('id')}']`)
                    .toggleClass('active')
                    .siblings()
                    .removeClass('active');

                if ($this[0].hasAttribute('data-is-menu')) {
                    e.preventDefault();
                }

                $this.children().attr('aria-expanded', $this.hasClass('active').toString());
            });
        });

        $('.menu-label button').each(function () {
            const $this = $(this);
            const enterKey = 13;
            const escapeKey = 27;

            $this.keydown((e) => {
                if (e.which === enterKey) {
                    $('.drop-down-links').trigger('focus');
                    $('.menu-label a, .menu-label button').attr('tabindex', '-1');
                }
            });

            $('.parent-label, .child-label, .link-item').keydown((e) => {
                if (e.which === escapeKey) {
                    $('.menu-wrapper .columns .active button').trigger('focus');
                    $('.menu-label a, .menu-label button').attr('tabindex', '0');
                }
            });
        });

        $('button.mega-menu').on('click', () => {
            $('.menu-label a, .menu-label button').attr('tabindex', '0');
        });

        $('.menu-label-2').each(function () {
            const $this2 = $(this);

            $this2.on('click', (event) => {
                event.stopPropagation();
                $this2.toggleClass('active')
                    .children('.mega-menu')
                    .toggleClass('active');

                if ($($this2).hasClass('active')) {
                    $($this2).children().attr('aria-expanded', 'true');
                } else {
                    $($this2).children().attr('aria-expanded', 'false');
                }
            });
        });

        $('.close-button').on('click', function () {
            $('.mega-menu').removeClass('active');
            $('.menu-label').removeClass('active');
            $(this).parent().removeClass('active');
        });
    }

    function advancedsearch () {
        $('#ui-datepicker-div').on('click', (event) => {
            event.stopPropagation();
        });
    }

    function showSearchBar () {
        $('.search').click(() => {
            $('.search').toggleClass('show-search');
            $('.website-search').toggleClass('is-hidden');
        });
    }

    function showMegaMenu () {
        $('.mega-menu').click(() => {
            $('.mega-menu').toggleClass('show-mega-menu');
            $('.mobile-header-btns').toggleClass('is-hidden');
            $('.mobile-menu').toggleClass('is-hidden');
        });
    }

    function alerts () {
        $('.alert-close').click(() => {
            $('.alert-holder').hide('slide', { direction: 'up' }, 'slow');

            const alertHash = $('.alert-holder').attr('data-alert-hash');

            const expiry = new Date();
            expiry.setTime(expiry.getTime() + 24 * 3600 * 1000); // 1 day
            document.cookie = `hide-alert-banner=${alertHash};path=/; expires=${expiry.toUTCString()}`;
        });
    }

    function alertPopup () {
        $('.close-alert-btn').click(() => {
            $('.alert-popout').hide('slide', { direction: 'up' }, 'slow');
        });

        $(window).click((e) => {
            if ($(e.target).parents('.alert-popout').length > 0) return;

            if ($(e.target).parents('.open-alert').length === 0 || $('.alert-popout').is(':visible')) {
                $('.alert-popout').hide('slide', { direction: 'up' }, 'slow');
            }
        });

        $('.open-alert').click((e) => {
            if (!$('.alert-popout').is(':visible')) {
                $('.alert-popout').show('slide', { direction: 'up' }, 'slow');
                e.stopPropagation();
            }
        });

        $(window).keydown((e) => {
            if (e.which === 27) {
                $('.alert-popout').hide();
            }
        });
    }

    function toggleTranslation () {
        $('.english-toggle').each(function () {
            const $this = $(this);
            $this.on('click', () => {
                $('.english-text').removeClass('is-hidden');
                $('.english-toggle').attr('aria-checked', 'true');
                $('.maori-toggle').attr('aria-checked', 'false');
                $('.maori-text').addClass('is-hidden');
                $('.english-text').attr('lang', 'en-NZ');
                $('html').attr('lang', 'en-NZ');
                $.cookie('translation', 'english', { expires: 90, path: '/' });
            });
        });

        $('.maori-toggle').each(function () {
            const $this = $(this);
            $this.on('click', () => {
                $('.english-text').addClass('is-hidden');
                $('.maori-toggle').attr('aria-checked', 'true');
                $('.english-toggle').attr('aria-checked', 'false');
                $('.maori-text').removeClass('is-hidden');
                $('.maori-text').attr('lang', 'mi');
                $('html').attr('lang', 'mi');
                $.cookie('translation', 'maori', { expires: 90, path: '/' });
            });
        });
    }

    function setTranslations () {
        if ($.cookie('translation') === null || $.cookie('translation') === 'english') {
            $('.english-text').removeClass('is-hidden');
            $('.maori-text').addClass('is-hidden');
            $('.english-toggle').attr('aria-checked', 'true');
            $('.maori-toggle').attr('aria-checked', 'false');
            $('.english-text').attr('lang', 'en-NZ');
        } else if ($.cookie('translation') === 'maori') {
            $('.english-text').addClass('is-hidden');
            $('.maori-text').removeClass('is-hidden');
            $('.maori-toggle').attr('aria-checked', 'true');
            $('.english-toggle').attr('aria-checked', 'false');
            $('.maori-text').attr('lang', 'mi');
        }
    }

    function toggleDropdownList () {
        $('.toggle-dropdown').each(function () {
            const $this = $(this);
            $this.on('click', function (event) {
                event.stopPropagation();
                $(this).find('.toggle-dropdown-content')
                    .toggleClass('active');
            });
        });
    }

    function toggleRssLinkCreate () {
        $('.rssfeed-details').hide();

        $('#Form_Form_Method_Email').on('click', (event) => {
            event.stopPropagation();
            $('#Form_Form_Email').show();
            $('#Form_Form_Email').siblings('.fieldholder-small-label').show();
            $('.subscribe-form .btn-toolbar').show();

            $('#SelectAllAll span.message.required').show();
            $('#UpdatesTitleMethodEmail span.message.required').show();

            $('.rssfeed-details').hide();
        });

        $('#Form_Form_Method_Web').on('click', (event) => {
            event.stopPropagation();
            $('#Form_Form_Email').siblings('.fieldholder-small-label').hide();
            $('#Form_Form_Email').hide();
            $('.subscribe-form .btn-toolbar').hide();

            $('#SelectAllAll span.message.required').hide();
            $('#UpdatesTitleMethodEmail span.message.required').hide();

            $('.rssfeed-details').show();
        });

        $('.generateRSSLink').on('click', (event) => {
            event.stopPropagation();
            $('.rss-go-to-link').remove();

            const frequency = $('#Form_Form_Frequency input:checked').val();
            const topicIds = $('form .taxonomies li input:checked').filter(function (index, element) {
                return ($(element).val() !== 'All');
            }).map(function (index, element) {
                return $(element).val();
            }).toArray();

            const rssLinkInputField = $('.rss-link');

            const baseRssLink = rssLinkInputField.attr('default');
            const rssLink = `${baseRssLink}?frequency=${encodeURIComponent(frequency)}&items=${encodeURIComponent(topicIds.join('-'))}`;
            rssLinkInputField.val(rssLink);

            const button = `<a href="${rssLink}" target="_blank" class="button rss-go-to-link"><span class="text">Go to RSS feed</span></a>`;
            $('.rssfeed-details .buttons').append(button);
        });
    }

    function subscribeSelectAll () {
    // select all check boxes
        $('input[id^="Form_Form_SelectAll_All"]').change(function () {
            if ($(this).is(':checked')) {
                $('#Form_Form_All :input').prop('checked', true);
                $('.taxonomies-children-holder').find("input[type='checkbox']").prop('checked', true);
            } else {
                $('#Form_Form_All :input').prop('checked', false);
                $('.taxonomies-children-holder').find("input[type='checkbox']").prop('checked', false);
            }
        });
        $('.check-children-box input').change(function () {
            if (!$(this).is(':checked')) {
                $('input[id^="Form_Form_SelectAll_All"]').prop('checked', false);
            }
        });

        $('.subscribe-form .select-all input').change(function () {
            // $(this).parent().parent().parent().siblings().css('background-color', 'red');
            const children = $(this).parent().parent().parent()
                .siblings();
            if ($(this).is(':checked')) {
                $(children).find("input[type='checkbox']").prop('checked', true);
            } else {
                $(children).find("input[type='checkbox']").prop('checked', false);
            }
        });

        $('.advanced-options-wrap .select-all input').change(function () {
            // $(this).parent().parent().parent().siblings().css('background-color', 'red');
            const children = $(this).parent().parent().parent()
                .siblings();
            if ($(this).is(':checked')) {
                $(children).find("input[type='checkbox']").prop('checked', true);
            } else {
                $(children).find("input[type='checkbox']").prop('checked', false);
            }
        });
    }

    $('.check-children-box label').each(function (index, value) {
        const label = $(this);
        if (label.val().length > 30) {
            $(label).text(`${label.context.text.substr(0, 30)}...`);
        }
    });

    function toggleMobileMenu () {
        $('.mobile-nav-toggle').each(function () {
            const $this = $(this);
            $this.on('click', () => {
                $('.mobile-menu').toggleClass('active');
                $('.mobile-nav-toggle').toggleClass('active');
                $('.static-mobile-menu').toggleClass('active');
                if ($('.mobile-nav-toggle').hasClass('active')) {
                    $('.mobile-nav-toggle').attr('aria-expanded', 'true');
                } else {
                    $('.mobile-nav-toggle').attr('aria-expanded', 'false');
                }
            });
        });
    }

    function removeFilterMobile () {
        $(window).on('resize', () => {
            if ($(window).width() < 768) {
                $('.news-filter-desktop').remove();
            }
        });

        $(window).on('load', () => {
            if ($(window).width() < 768) {
                $('.news-filter-desktop').remove();
            }
        });
    }

    function clearFilters () {
        $('.clear-filter-search').on('click', (event) => {
            window.location.href = '/find';
        });
    }

    function focusContactSuccess () {
        if ($('#uff').is(':visible')) {
            $('#uff').attr('tabindex', '-1').focus();
        }
    }

    $(document).ready(() => {
        window.toggleDropdownList = toggleDropdownList;

        alerts();
        alertPopup();
        keyDatesCarousel();
        megamenu();
        advancedsearch();
        showSearchBar();
        showMegaMenu();
        subscribeSelectAll();
        toggleTranslation();
        activeCarouselItem();
        toggleDropdownList();
        toggleRssLinkCreate();
        setTranslations();
        toggleMobileMenu();
        removeFilterMobile();
        copyLink();
        setupToc();
        clearFilters();
        focusContactSuccess();
    });
});



// WEBPACK FOOTER //
// ./src/js/app/functions.js